import { useRouter } from "@faire/retailer/app/_lib/routing/useRouter";
import { UsePrefetchOnHover } from "@faire/web/ui/hooks/nextjs/usePrefetchOnHover_DO_NOT_RENAME";
import { startTransition, useCallback, useEffect, useState } from "react";

import { getSettingNextJSRSCPrefetching } from "@faire/retailer/settings/getSettingNextJSRSCPrefetching";

// ts-prune-ignore-next
export const usePrefetchOnHover: UsePrefetchOnHover = (
  href,
  prefetch = true
) => {
  const router = useRouter();
  const [shouldPrefetch, setShouldPrefetch] = useState(false);

  useEffect(() => {
    if (shouldPrefetch) {
      href && router.prefetch(href);
    }
  }, [href, router, shouldPrefetch]);

  const onMouseOver = useCallback(() => {
    // prefetch unless we explicitly say not to
    if (
      !shouldPrefetch &&
      getSettingNextJSRSCPrefetching() &&
      href &&
      prefetch
    ) {
      startTransition(() => setShouldPrefetch(true));
    }
  }, [href, prefetch, shouldPrefetch]);

  const onFocus = useCallback(() => {
    if (!shouldPrefetch) {
      onMouseOver();
    }
  }, [onMouseOver, shouldPrefetch]);

  return {
    onMouseOver,
    onFocus,
  };
};
